//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import XButton from 'vux/src/components/x-button';
import { mapState } from 'vuex';
import { setTitle } from '@/utils';
import env from '@/utils/env';
import { initCanvas } from '@/utils/share';
import { roleTypeMap } from '@/utils/map';
import UBT from '@/utils/ubt';

async function saveFile(data, filename) {
  const saveLink = document.createElement('a');
  saveLink.href = data;
  saveLink.download = filename;

  const event = document.createEvent('MouseEvents');
  event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  saveLink.dispatchEvent(event);
}
export default {
  components: { XButton },
  data() {
    return {
      imgPreviewSrc: '',
      roleType: ''
    };
  },
  computed: {
    UIconfig() {
      switch (+this.roleType) {
        case +roleTypeMap.leader:
          return {
            url: this.activity.leaderUrl,
            color: this.activity.leaderColour
          };
        case +roleTypeMap.member:
          return {
            url: this.activity.memberUrl,
            color: this.activity.memberColour
          };
        default:
          return {
            url: this.activity.couponUrl,
            color: this.activity.couponColour
          };
      }
    },
    ...mapState({
      activity: state => state.activity.activity,
      userName: state => state.user.loginResult.userName
    })
  },
  async mounted() {
    const { activityId, roleType, sourceId } = this.$route.query;
    if (
      +roleType !== +this.$store.state.user.loginResult.roleType
        || +activityId !== +this.$store.state.user.loginResult.activityId
        || (this.$store.state.user.loginResult.sourceId
         && sourceId !== this.$store.state.user.loginResult.sourceId)
    ) {
      this.$router.replace({
        name: 'login',
        query: this.$route.query
      });
      this.$throw(new Error('登录已失效，请重新登录'));
      return;
    }
    let pageId = '';
    switch (+roleType) {
      case 1:
        pageId = 'H5_换电_领队名片页';
        break;
      case 2:
        pageId = 'H5_换电_队员名片页';
        break;
      default:
    }
    if (pageId) {
      UBT.pageView({
        pageId,
      });
    }
    try {
      await this.initState();
      const leaderTexts = [
        `扫码成为“${this.userName}”的推广员`,
        `一起推广“${this.formatStr(`${this.activity.activityName || ''}`, 10)}”`
      ];
      const leaderQrcodeUrl = `${window.location.origin + window.location.pathname}#/login?autologin=1&activityId=${activityId}&sourceId=${this.$store.state.user.loginResult.promotionUserId}&roleType=${roleTypeMap.member}`;
      const memberTexts = [
        '扫码领券'
      ];
      const memberQrcodeUrl = `${window.location.origin + window.location.pathname}#/login?autologin=1&activityId=${activityId}&sourceId=${this.$store.state.user.loginResult.promotionUserId}&roleType=${roleTypeMap.user}`;
      const userTexts = [
        '扫码领券'
      ];
      const userQrcodeUrl = `${window.location.origin + window.location.pathname}#/login?autologin=1&activityId=${activityId}&sourceId=${sourceId}&roleType=${roleTypeMap.user}`;
      let texts;
      let qrcodeUrl;
      switch (+this.roleType) {
        case +roleTypeMap.leader:
          texts = leaderTexts;
          qrcodeUrl = leaderQrcodeUrl;
          break;
        case +roleTypeMap.member:
          texts = memberTexts;
          qrcodeUrl = memberQrcodeUrl;
          break;
        case +roleTypeMap.user:
          texts = userTexts;
          qrcodeUrl = userQrcodeUrl;
          break;
        default:
      }
      // eslint-disable-next-line
      console.log('qrcodeUrl', qrcodeUrl);
      this.imgPreviewSrc = await initCanvas({
        canvas: this.$refs.canvas,
        qrcodeUrl,
        texts,
        fillStyle: this.UIconfig.color,
        backgroundImg: this.UIconfig.url,
      });
    } catch (e) {
      this.$throw(e);
    }
  },
  methods: {
    formatStr(str, maxLen) {
      if (!str) return '';
      if (str.length <= maxLen) {
        return str;
      }
      return `${str.slice(0, 10)}...`;
    },
    async initState() {
      const { activityId } = this.$route.query;
      let { roleType = roleTypeMap.user } = this.$route.query;
      if (!activityId) {
        this.$throw(new Error('活动不存在'));
      }
      if ([+roleTypeMap.leader, +roleTypeMap.member].indexOf(+roleType) === -1) {
        // 不认识的roleType都默认为用户s
        roleType = roleTypeMap.user;
      }
      Object.assign(this, { activityId, roleType });
      await this.getActivity(activityId, roleType);
    },
    async getActivity(activityId, roleType) {
      await this.$store.dispatch('getActivity', { activityId, roleType });
      if (+this.roleType === +roleTypeMap.leader) {
        setTitle('我的推广');
      } else if (+this.roleType === +roleTypeMap.member) {
        setTitle('我的推广');
      } else {
        setTitle('我的名片');
      }
    },
    download() {
      const { roleType } = this.$route.query;
      let pageId = '';
      let buttonName = '';
      switch (+roleType) {
        case 1:
          pageId = 'H5_换电_领队名片页';
          buttonName = 'H5_换电_领队名片页_保存名片';
          break;
        case 2:
          pageId = 'H5_换电_队员名片页';
          buttonName = 'H5_换电_队员名片页_保存名片';
          break;
        default:
      }
      if (pageId) {
        UBT.clickButton({
          buttonName,
          pageId,
        });
      }
      if (env.isWeixin) {
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '长按保存图片或截图',
        });
      } else if (env.isAlipayClient) {
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '暂不支持该功能，请在浏览器打开网页',
        });
      } else {
        this.$vux.toast.show({
          type: 'text',
          width: 'auto',
          text: '长按保存图片或截图',
        });
        const { canvas } = this.$refs;
        const dataURL = canvas.toDataURL('image/jpeg', 1.0);
        saveFile(dataURL, '名片.jpg');
      }
    },
    query() {
      const { sourceId, roleType } = this.$route.query;
      let pageId = '';
      let buttonName = '';
      switch (+roleType) {
        case 1:
          pageId = 'H5_换电_领队名片页';
          buttonName = 'H5_换电_领队名片页_查看绩效';
          break;
        case 2:
          pageId = 'H5_换电_队员名片页';
          buttonName = 'H5_换电_队员名片页_查看绩效';
          break;
        default:
      }
      if (pageId) {
        UBT.clickButton({
          buttonName,
          pageId
        });
      }
      const { activityId } = this.$route.query;
      if (this.roleType * 1 === 1) {
        this.$router.push({
          name: 'record',
          query: {
            activityId,
            roleType: this.roleType,
            sourceId,
          }
        });
      } else if (this.roleType * 1 === 2) {
        this.$router.push({
          name: 'recordSub',
          query: {
            activityId,
            roleType: this.roleType,
            sourceId,
            subRoleType: this.subRoleType,
          }
        });
      }
    },
  }
};
